import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CloudwatchLogMockService {
  constructor() {
    console.log('CloudwatchMockLogService init');
  }

  public logError(..._args: any[]) {}
}
